export { config } from "./tamagui.config";
